import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatCardModule } from "@angular/material/card";

import { DurationPipe } from "./pipes/duration.pipe";
import { PhoneNumberPipe } from "./pipes/phone-number.pipe";
import { DateTimePipe } from "./pipes/date-time.pipe";
import { LoadingSpinnerComponent } from "./components/loading-spinner/loading-spinner.component";
import { ErrorMessageComponent } from "./components/error-message/error-message.component";
import { InvocationsTableComponent } from "./components/invocations-table/invocations-table.component";

@NgModule({
  declarations: [
    DurationPipe,
    PhoneNumberPipe,
    DateTimePipe,
    LoadingSpinnerComponent,
    ErrorMessageComponent,
    InvocationsTableComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCardModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatIconModule,
    DurationPipe,
    PhoneNumberPipe,
    DateTimePipe,
    LoadingSpinnerComponent,
    ErrorMessageComponent,
    InvocationsTableComponent,
  ],
})
export class SharedModule {}
